import { apiAdd, apiGet } from "../../../API/Service/apiClient";

export const handleGet_data = async (  
  {setListLoading,setCloth,setPrintType,setPrices}
  ) => {
    setListLoading(true);
  let data={limit:100,page:1};
  try {
    const resData = await apiGet("sublimation_print_type", data);         
    const resDataCloth = await apiGet("sublimation_cloth", data);
    const resDataPrices = await apiGet("sublimation_price", {limit:1000,page:1});
    setCloth(resDataCloth?.data)
    setPrintType(resData?.data)    
    let result= await combineClothAndPrintTypes(
      resDataCloth?.data,resData?.data,resDataPrices?.data)
    setPrices(result);
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setListLoading(false);    
  }
};

export const combineClothAndPrintTypes = async(clothArr, printTypeArr,priceData) => {
  const result = [];
  clothArr.forEach(clothItem => {
    printTypeArr.forEach(printItem => {
      result.push({
        cloth_id: clothItem.id,
        print_type_id: printItem.id,
        sub_mrp: priceData.find(
          d => d.cloth_id === clothItem.id && d.print_type_id === printItem.id
        )?.sub_mrp || 0,
        sub_price: priceData.find(
          d => d.cloth_id === clothItem.id && d.print_type_id === printItem.id
        )?.sub_price || 0
      });
    });
  });

  return result;
};

export const updateSubPrice = (cloth_id, print_type_id, value,setPrices) => {
  setPrices(prev =>
    prev.map(entry =>
      entry.cloth_id === cloth_id && entry.print_type_id === print_type_id
        ? { ...entry, sub_price: value }
        : entry
    )
  );
};

export const handleSubmit_data = async({data,setLoading,showToast}) => {
  setLoading(true);  
  try {
    let newData={
      dataList:data,
      action:'bulk_price'
    }
    const resData = await apiAdd("sublimation_price", newData);  
    if(resData?.data?.length > 0){
      showToast("Sublimation prices saved successfully","success")
    }else{
      showToast("Something went wrong! Please try again", "danger")
    }          
    
     
  } catch (error) {
    console.log("Something went wrong! Please try again", "danger");
  } finally {
    setLoading(false);    
  }
};